export default function Horses(){
    return <>

    </>
}